import { render, staticRenderFns } from "./ProgrammingBoard.vue?vue&type=template&id=4731939f&scoped=true&"
import script from "./ProgrammingBoard.vue?vue&type=script&lang=ts&"
export * from "./ProgrammingBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4731939f",
  null
  
)

export default component.exports